module.exports = __webpack_public_path__ + "static/img/hb_19-min.161d638.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_19-min.png
// module id = 0k++
// module chunks = 1